// src/components/Commands.js
import React, { useState } from 'react';
import { Icons } from './Icons';

const adminCommands = [
  { command: '/settings', description: 'Открыть настройки чата с постраничной навигацией' },
  { command: '/user [ID]', description: 'Информация о пользователе. Флаги: -f (полная), -mc (в чат модерации)' },
  { command: '/note [ID] [текст]', description: 'Создать заметку о пользователе' },
  { command: '/unnote [номер]', description: 'Удалить заметку по номеру' },
  { command: '/warn [ID] [причина]', description: 'Выдать предупреждение. Флаги: -d (удалить сообщение), -i (бессрочное)' },
  { command: '/unwarn [номер]', description: 'Снять предупреждение по номеру' },
  { command: '/mute [ID] [время] [причина]', description: 'Запретить писать. Формат: 5m, 2h, 3d, 1M' },
  { command: '/unmute [ID]', description: 'Снять ограничение на отправку сообщений' },
  { command: '/ban [ID] [время] [причина]', description: 'Заблокировать пользователя. Формат: 5m, 2h, 3d, 1M' },
  { command: '/unban [ID]', description: 'Разблокировать пользователя' },
  { command: '/raidMode', description: 'Включить режим антирейда вручную' },
  { command: '/unRaidMode', description: 'Отключить режим антирейда' },
  { command: '/onlinepanel', description: 'Получить доступ к веб-панели администратора' },
  { command: '/updateonlineadmins', description: 'Обновить список администраторов в онлайн-панели' }
];

const userCommands = [
  { command: '/report', description: 'Сообщить о нарушителе (ответом на сообщение)' },
  { command: '/user', description: 'Узнать информацию о себе' },
  { command: '/help', description: 'Создать запрос в службу поддержки' },
  { command: '/kickme', description: 'Выйти из чата (если разрешено)' },
  { command: '/updatesecretcode', description: 'Обновить секретный код для онлайн-панели' }
];

function Commands() {
  const [activeTab, setActiveTab] = useState('admin');

  return (
    <section id="commands" className="commands">
      <div className="container">
        <div className="section-header">
          <h2>Команды бота</h2>
          <p>Управляйте чатом с помощью простых и понятных команд</p>
        </div>
        <div className="commands-tabs">
          <button 
            className={`tab-btn ${activeTab === 'admin' ? 'active' : ''}`}
            onClick={() => setActiveTab('admin')}
          >
            <Icons.Settings />
            Для администраторов
          </button>
          <button 
            className={`tab-btn ${activeTab === 'user' ? 'active' : ''}`}
            onClick={() => setActiveTab('user')}
          >
            <Icons.User />
            Для пользователей
          </button>
        </div>
        <div className="commands-list">
          {(activeTab === 'admin' ? adminCommands : userCommands).map((cmd, index) => (
            <div key={index} className="command-item">
              <code className="command-code">{cmd.command}</code>
              <span className="command-desc">{cmd.description}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Commands;